import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors.ts';

const CursorContainer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 99999999;
  `;

const CursorDot = styled.div`
  position: fixed;
  width: 0.5rem;
  height: 0.5rem;
  background: ${colors.neutral[300]};
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.2s ease;
  z-index: 1;
  opacity: 0;
  `;

const CursorCircle = styled.div`
  position: fixed;
  border: 1px solid ${colors.neutral[300]};
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: 
    transform 0.005s ease-out, 
    background 0.2s ease, 
    border 0.2s ease, 
    width 0.2s ease, 
    height 0.2s ease
  ;
  transition-delay: .1s;
  background: ${colors.neutral[100]}80;
`;

const Cursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isPointer, setIsPointer] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    // Check if device is mobile
    const checkDevice = () => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsDesktop(!isMobile);
    };

    // Initial check
    checkDevice();

    const updatePosition = (e) => {
      const newPosition = { x: e.clientX, y: e.clientY };
      setPosition(newPosition);
      // Store globally for Toast component to access
      window.lastMousePosition = newPosition;
    };

    const handlePointer = (e) => {
      const computedStyle = window.getComputedStyle(e.target);
      const isInteractive = computedStyle.cursor === 'pointer' || e.target.tagName === 'BUTTON' || e.target.tagName === 'A';
      setIsPointer(isInteractive);
      // Hide default cursor for interactive elements
      e.target.style.cursor = 'none';
    };

    const handleVisibility = () => {
      setIsVisible(document.visibilityState === 'visible');
    };

    // Set initial visibility
    handleVisibility();

    // Add event listeners
    window.addEventListener('mousemove', updatePosition);
    window.addEventListener('mouseover', handlePointer);
    document.addEventListener('visibilitychange', handleVisibility);

    // Hide default cursor
    document.body.style.cursor = 'none';

    return () => {
      window.removeEventListener('mousemove', updatePosition);
      window.removeEventListener('mouseover', handlePointer);
      document.removeEventListener('visibilitychange', handleVisibility);
      document.body.style.cursor = 'auto';
    };
  }, []);

  // Don't render anything if not on desktop
  if (!isDesktop) return null;

  return (
    <CursorContainer style={{ display: isVisible ? 'block' : 'none' }}>
      <CursorDot
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: `translate(-50%, -50%) scale(${isPointer ? 0.5 : 1})`,
          opacity: `${isPointer ? '1' : '0'}`
        }}
      />
      <CursorCircle
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          transform: `translate(-50%, -50%)`,
          width: `${isPointer ? '60px' : '40px'}`,
          height: `${isPointer ? '60px' : '40px'}`,
          borderColor: isPointer ? colors.neutral[800] : colors.neutral[700],
        }}
      />
    </CursorContainer>
  );
};

export default Cursor;
